import { render, staticRenderFns } from "./SellerTrackingRecovery.vue?vue&type=template&id=530d5a1c&scoped=true&"
import script from "./SellerTrackingRecovery.vue?vue&type=script&lang=js&"
export * from "./SellerTrackingRecovery.vue?vue&type=script&lang=js&"
import style0 from "./SellerTrackingRecovery.vue?vue&type=style&index=0&id=530d5a1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530d5a1c",
  null
  
)

export default component.exports